type ProductIconProps = {
  className?: string
}

const ProductIcon = ({ className }: ProductIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      className={className}
    >
      <path fill="currentColor" d="M4.5 0H0v4.5h1V1h3.5V0ZM0 9.5V14h4.5v-1H1V9.5H0ZM14 4.5V0H9.5v1H13v3.5h1ZM9.5 14H14V9.5h-1V13H9.5v1ZM11.745 4.065l-4.5-2.5a.5.5 0 0 0-.5 0l-4.5 2.5A.5.5 0 0 0 2 4.5v5a.5.5 0 0 0 .255.435l4.5 2.5a.5.5 0 0 0 .5 0l4.5-2.5A.5.5 0 0 0 12 9.5v-5a.5.5 0 0 0-.255-.435ZM7 2.57l3.47 1.93L7 6.43 3.53 4.5 7 2.57ZM3 5.35l3.5 1.945v3.855L3 9.205V5.35Zm4.5 5.8V7.295L11 5.35v3.855L7.5 11.15Z" />
    </svg>
  )
}

export default ProductIcon
